const COUNTRY_FLAG_FORMATS = {
  us: 'svg'
}

export function countryFlagUrl (countryCode) {
  const format = COUNTRY_FLAG_FORMATS[countryCode] || 'png'
  return `/img/country-flags/${countryCode}.${format}`
}
